import { useMutation, useQuery } from 'react-query';
import { RemoteCalendarRepo } from '@repository/calendar/CalendarRepo';
// import CalendarMock from './CalendarMock';
import CalendarCountRq from '@domain/rq/calendar/CalendarCountRq';
import CalendarPcListRq from '@domain/rq/calendar/CalendarPcListRq';
import CalendarUserFilterRq from '@domain/rq/calendar/CalendarUserFilterRq';
import { CalendarPcListVO } from '@domain/vo/calendar/CalendarPcListVO';
import { CalendarFilterFormVO } from '@domain/vo/calendar/CalendarFilterFormVO';
import { CalendarUserFilterVO } from '@domain/vo/calendar/CalendarUserFilterVO';
import ObjectUtil from '@utils/object/util';

// const calendarMockRepo = new CalendarMock();
const calendarRepo = new RemoteCalendarRepo();

export const calendarPcListKeys = (vo: CalendarFilterFormVO) => {
  const sortedVO = ObjectUtil.sortObjectKeys(vo);
  return ['calendar', 'list', JSON.stringify(sortedVO)];
};

const keys = ['calendar'];

const fetchCalendarCount = async (vo: CalendarFilterFormVO) => {
  const rq = new CalendarCountRq(vo);
  const { data } = await calendarRepo.fetchCalendarCount(rq);
  return data;
};

const fetchCalendarPcList = async (vo: CalendarFilterFormVO) => {
  const rq = new CalendarPcListRq(vo);
  const { data } = await calendarRepo.fetchCalendarPcList(rq);
  return new CalendarPcListVO(data);
};

const fetchSearchJobTitle = async (keyword: string) => {
  const { data } = await calendarRepo.fetchSearchJobTitle(keyword);
  return data;
};

const fetchCalendarFilter = async () => {
  const { data } = await calendarRepo.fetchCalendarFilter();
  return new CalendarUserFilterVO(data);
};

const updateCalendarFilter = async (vo: CalendarFilterFormVO) => {
  const rq = new CalendarUserFilterRq(vo);
  const { data } = await calendarRepo.updateCalendarFilter(rq);
  return data;
};

export function useCalendarCount(vo: CalendarFilterFormVO, enabled: boolean) {
  return useQuery([...keys, 'count', vo], () => fetchCalendarCount(vo), { enabled, keepPreviousData: true });
}

export function useCalendarPcList(vo: CalendarFilterFormVO, enabled: boolean) {
  //객체 key값을 순서대로 수정
  return useQuery(calendarPcListKeys(vo), () => fetchCalendarPcList(vo), { enabled });
}

export function useSearchJobTitle(keyword: string, enabled: boolean) {
  return useQuery([...keys, 'search', keyword], () => fetchSearchJobTitle(keyword), { enabled });
}

export function useCalendarFilter(enabled: boolean, onSuccess?: (vo: CalendarUserFilterVO) => void) {
  return useQuery([...keys, 'filter'], fetchCalendarFilter, {
    enabled,
    onSuccess,
  });
}

export function useUpdateCalendarFilter() {
  return useMutation((vo: CalendarFilterFormVO) => updateCalendarFilter(vo));
}
